import { render, staticRenderFns } from "./CardLiberacoesPendentes.vue?vue&type=template&id=54c6e41e&"
import script from "./CardLiberacoesPendentes.vue?vue&type=script&lang=js&"
export * from "./CardLiberacoesPendentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports